import { render, staticRenderFns } from "./GamePowerupPercentage.vue?vue&type=template&id=0747ee2a&scoped=true&"
import script from "./GamePowerupPercentage.vue?vue&type=script&lang=js&"
export * from "./GamePowerupPercentage.vue?vue&type=script&lang=js&"
import style0 from "./GamePowerupPercentage.vue?vue&type=style&index=0&id=0747ee2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0747ee2a",
  null
  
)

export default component.exports